// Universal Benefit Cards Configuration
// Single source of truth for card metadata
export const UNIVERSAL_BENEFIT_CARD_CONFIG = {
  'free-monday': {
    image: 'ticket.svg',
    messageKey: 'freeMonday',
  },
  'personalized-games': {
    image: 'trophy.beta.svg',
    messageKey: 'personalizedGames',
  },
  'double-star-personal-cup': {
    image: 'tumbler.svg',
    messageKey: 'doubleStarPersonalCup',
  },
  'coffee-loop': {
    image: 'mug.svg',
    messageKey: 'coffeeLoop',
  },
};

/**
 * Get card metadata by ID
 * @param {string} id - Card identifier
 * @returns {object} Card metadata with image and messageKey
 */
export const getCardMetadata = (id) => {
  return UNIVERSAL_BENEFIT_CARD_CONFIG[id] || { image: null, messageKey: null };
};
